import React from 'react';
import { FaLinkedin, FaGithub, FaTerminal, FaCodeBranch } from 'react-icons/fa';
import { skills } from '../constants';
import '../styles/AboutTwo.scss';

const AboutTwo = () => {
  return (
    <main className="tech-portfolio">
      {/* Background Matrix/Grid Overlay Element */}
      <div className="bg-grid-overlay" />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="terminal-badge">
          <FaTerminal className="icon" />
          <span>status: available_for_work</span>
        </div>

        <h1 className="headline">
          Hello, I'm <span className="tech-gradient">Estelo Abellanosa</span>
        </h1>

        <p className="hero-tagline">
          Frontend Developer &amp; UI/UX Designer.
        </p>

        <div className="terminal-box">
          <div className="terminal-header">
            <span className="dot red" />
            <span className="dot yellow" />
            <span className="dot green" />
            <span className="terminal-title">about_me.config.js</span>
          </div>
          <div className="terminal-body">
            <p>
              <span className="code-keyword">const</span> developer = &#123;<br />
              &nbsp;&nbsp;stack: [<span className="code-str">'React'</span>, <span className="code-str">'JavaScript'</span>, <span className="code-str">'Figma'</span>, <span className="code-str">'Firebase'</span>],<br />
              &nbsp;&nbsp;workflow: [<span className="code-str">'VS Code'</span>, <span className="code-str">'GitHub CI/CD'</span>, <span className="code-str">'Netlify'</span>],<br />
              &nbsp;&nbsp;focus: <span className="code-str">'Responsive Web Apps & UI/UX Systems'</span><br />
              &#125;;
            </p>
          </div>
        </div>

        <div className="hero-actions">
          <a
            href="https://www.linkedin.com/in/estelo-abellanosa-83a335186/"
            className="tech-btn primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin /> ./connect_linkedin
          </a>
          <a
            href="https://github.com/estelo2jz" 
            className="tech-btn secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub /> ./view_github
          </a>
        </div>
      </section>

      {/* Skills & Tech Stack Section */}
      <section className="skills-section">
        <div className="section-title">
          <FaCodeBranch className="title-icon" />
          <h2>// Tech Stack & Skills</h2>
        </div>

        <div className="tech-grid">
          {skills.map((skill, index) => (
            <div className="tech-card" key={index}>
              <div className="card-top">
                <img src={skill.imageUrl} alt={skill.name} className="skill-logo" />
                <h3 className="skill-name">{skill.name}</h3>
              </div>
              <ul className="skill-bullets">
                {skill.descOne && <li>{skill.descOne}</li>}
                {skill.descTwo && <li>{skill.descTwo}</li>}
                {skill.descThree && <li>{skill.descThree}</li>}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default AboutTwo;